import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[inputAutoFocus]'
})
export class AutofocusDirective implements AfterContentInit {

    @Input() public inputAutoFocus: boolean;

    public constructor(private el: ElementRef) {

    }

    public ngAfterContentInit() {

        setTimeout(() => {
            console.log('get focus')
            this.el.nativeElement.focus();
            this.el.nativeElement.select();
        }, 100);

    }

}